import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import "../../styles/common/popup.scss";

const AddImagePopup = ({ open, handleClose, onInsert }) => {
  const [urls, setUrls] = useState(["", "", ""]);
  const [visibleCount, setVisibleCount] = useState(1);

  const isInsertDisabled =
    urls.map((u) => u.trim()).filter((u) => u).length === 0;

  const handleChange = (index, value) => {
    setUrls((prev) => {
      const next = [...prev];
      next[index] = value;
      return next;
    });
  };

  const handleAddField = () => {
    setVisibleCount((prev) => (prev < 3 ? prev + 1 : prev));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const valid = urls.map((u) => u.trim()).filter((u) => u);
    if (valid.length === 0) return;
    if (onInsert) onInsert(urls);
  };

  useEffect(() => {
    if (open) {
      setUrls(["", "", ""]);
      setVisibleCount(1);
    }
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div className="common-popup-overlay high-z-index" onClick={handleClose}>
      <div
        className="common-popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="popup-header with-close">
          <h2>Add Images</h2>
          <button
            type="button"
            className="popup-close-button"
            onClick={handleClose}
          >
            ×
          </button>
        </div>

        <div className="popup-content">
          <form onSubmit={handleSubmit}>
            <div className="add-image-row">
              <div className="add-image-input-wrapper">
                <div className="popup-form-group">
                  <label>Image URL 1</label>
                  <input
                    type="text"
                    className="popup-input"
                    placeholder="https://..."
                    value={urls[0]}
                    onChange={(e) => handleChange(0, e.target.value)}
                  />
                </div>

                {visibleCount > 1 && (
                  <div className="popup-form-group">
                    <label>Image URL 2 (optional)</label>
                    <input
                      type="text"
                      className="popup-input"
                      placeholder="https://..."
                      value={urls[1]}
                      onChange={(e) => handleChange(1, e.target.value)}
                    />
                  </div>
                )}

                {visibleCount > 2 && (
                  <div className="popup-form-group">
                    <label>Image URL 3 (optional)</label>
                    <input
                      type="text"
                      className="popup-input"
                      placeholder="https://..."
                      value={urls[2]}
                      onChange={(e) => handleChange(2, e.target.value)}
                    />
                  </div>
                )}
              </div>
              <div className="add-image-button-wrapper">
                <button
                  type="button"
                  className="popup-submit-button add-image-add-button"
                  onClick={handleAddField}
                  disabled={visibleCount >= 3}
                >
                  +
                </button>
              </div>
            </div>
            <div className="popup-actions">
              <button
                type="button"
                className="popup-cancel-button"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="popup-submit-button"
                disabled={isInsertDisabled}
              >
                Insert Images
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AddImagePopup;
